import { ScheduledSectionStatusServant } from '../../servants/scheduled_section_status_servant';
import { RegistrationFailureModel } from '../../models/registration_failure_model';
import { TileErrorMessageTypesAndMessagesStrategy } from '../../strategies/section_tile_error_strategy';
import {
  ISection,
  ISectionTileErrorNotificationMessage,
  IFailedSection
} from '../../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';

class ScheduledSectionNotification {
  private section: ISection;
  private isStatusPending: boolean;
  private pinDefinition: string;
  // making it as an array we are expecting future requirement to show multiple error message
  private errorMessages: Array<ISectionTileErrorNotificationMessage & IFailedSection>;

  constructor(
    private ngRegistrationFailureModel: RegistrationFailureModel,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant
  ) {}

  initialize() {
    this.errorMessages = [];
    this.isStatusPending = this.ngScheduledSectionStatusServant.isStatusPending(this.section);
    const failedSectionDetails = this.ngRegistrationFailureModel.get(this.section.id);
    const isValidFailureForCurrentStatus = this.ngScheduledSectionStatusServant.isValidFailureForCurrentStatus(
      this.section,
      _4.get(failedSectionDetails, 'type', '')
    );

    if (failedSectionDetails && isValidFailureForCurrentStatus) {
      this.errorMessages = [
        {
          ...failedSectionDetails,
          ...TileErrorMessageTypesAndMessagesStrategy[failedSectionDetails.type]
        }
      ];
    }
  }

  $onInit() {
    this.initialize();
  }

  $onChanges(changes: { section: ISection }) {
    this.initialize();
  }
}
class ScheduledSectionNotificationComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      section: '<'
    };
    this.controller = ScheduledSectionNotification;
    this.templateUrl =
      'capability-ng-scheduler/src/views/course_scheduler/components/scheduled_section_notification/scheduled_section_notification.html';
  }
}
angular
  .module('capability-ng-scheduler')
  .component('scheduledSectionNotification', new ScheduledSectionNotificationComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/scheduled_section_notification/scheduled_section_notification.ts